export enum InvoiceMode {
  NONE = 'none',
  AT_ORDER = 'at_order',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly'
}
